export default "__VITE_ASSET__bIROzaK7__"